import React, { useLayoutEffect, useRef, useState } from "react";
import i18n from "@euroland/libs/locale/i18n";
import { RadioButton, RadioButtonGroup } from "@euroland/base-ui";

import useInstruments, { useInstrument } from "../hooks/useInstruments";
import { KEY_BOARD } from "../constant/common";
import TickerName from "./TickerName";
import Check from "./ui/icons/Check";
import Uncheck from "./ui/icons/Uncheck";

export default function MultipleTickerRadio() {
  const radioElement = useRef();
  const [loading, setLoading] = useState(true);
  const [{ instruments }] = useInstruments();
  const [{ selectedInstrument }, { onChangeSelectedInstrument }] = useInstrument();

  const handleKeyUp = e => {
    const code = e.keyCode ? e.keyCode : e.which;
    // User press Tab
    // Scroll to current focusing element if radio ticker scroll
    if (code === 9) {
      const activeElement = document.activeElement;
      // activeElement.scrollIntoView({
      //   block: "nearest",
      //   inline: "start",
      //   behavior: "smooth",
      // });
      activeElement.focus({ preventScroll: true });
    }
    // active ticker when user press Enter
    else if (e.key === KEY_BOARD.ENTER) {
      const activeElement = document.activeElement;
      const idTicker = activeElement.getAttribute("id-ticker");
      if (idTicker) onChangeSelectedInstrument(Number(idTicker));
    }
  };

  useLayoutEffect(() => {
    const children = radioElement.current.childNodes;
    let activeChildren = null;
    for (const i of children) {
      if (i.className?.includes("checked")) {
        activeChildren = i;
        break;
      }
    }
    if (activeChildren) {
      // activeChildren.scrollIntoView({
      //   block: "nearest",
      //   inline: "start",
      // });
      // activeChildren.focus({ preventScroll: true });
      const timer = setTimeout(() => {
        clearTimeout(timer);
        setLoading(false);
      }, 100);
    } else {
      setLoading(false);
    }
  }, [instruments]);

  return (
    <>
      <RadioButtonGroup
        name="ticker"
        className="MultipleTickerRadio"
        label={i18n.translate("chooseInstruments")}
        ref={radioElement}
        valueSelected={selectedInstrument.instrumentId}
        onChange={instrumentId => {
          onChangeSelectedInstrument(instrumentId);
        }}
        onKeyUp={handleKeyUp}
        iconChecked={<div className="icon-wrapper"><Check role="presentation" /></div>}
        iconUnchecked={<div className="icon-wrapper"><Uncheck role="presentation" /></div>}
        style={{ opacity: loading ? 0 : 1 }}
      >
        {instruments.map(ticker => {
          const { instrumentId, shareName, marketAbbreviation } = ticker;
          // const ariaLabel = marketAbbreviation
          //   ? `${shareName} ${i18n.translate("marketAbbreviationFormat", marketAbbreviation)}`
          //   : shareName;
          return (
            <RadioButton
              key={instrumentId}
              id={instrumentId}
              labelText={<TickerName shareName={shareName} marketAbbreviation={marketAbbreviation} />}
              value={instrumentId}
              // ariaLabel={ariaLabel}
            />
          );
        })}
      </RadioButtonGroup>
    </>
  );
}

MultipleTickerRadio.propTypes = {};
